import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import AgentStatusPanel from './AgentStatusPanel';
import TraceLink from '../agent-common/TraceLink';
import { useVoyagerStore } from '../../stores/useVoyagerStore';
import type { LandingAgentTurn } from '../../stores/slices/landingAgentSlice';

export default function AnalysisProgressLink({ turn }: { turn: LandingAgentTurn }) {
  const threadId = useVoyagerStore(s => s.currentThreadId);
  const href = `/threads/${encodeURIComponent(threadId || '')}?run=${encodeURIComponent(turn.id)}`;
  const [open, setOpen] = useState(() => new URLSearchParams(window.location.search).get('run') === turn.id);
  const progress = turn.diagnosisProgress;
  const session = turn.sessionId || progress?.session_id;
  return <>
    <Button size="small" component="a" href={href} onClick={event => { event.preventDefault(); setOpen(true); }} sx={{ textTransform: 'none', textDecoration: 'underline' }}>View progress</Button>
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm" aria-labelledby={`progress-${turn.id}`}>
      <DialogTitle id={`progress-${turn.id}`}>Analysis progress</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>{turn.userText}</Typography>
        {turn.diagnosisOperationId ? <>
          <Typography>{turn.diagnosisDisconnected ? 'Connection interrupted. Reconnect to get the latest status.' :
            turn.diagnosisCancelPending ? 'Stop requested — waiting for confirmation.' :
            `Status: ${progress?.status || turn.status}`}</Typography>
          <Typography>{progress?.queries_completed || 0} warehouse queries completed · {progress?.queries_started || 0} started</Typography>
          {turn.diagnosisParentTurnId && <Typography variant="body2">Continuing the previous analysis. Saved query results are reused; these counts show new warehouse work.</Typography>}
          {turn.error && <Typography color="error">{turn.error}</Typography>}
        </> : <AgentStatusPanel turn={turn} defaultCollapsed={false} />}
        <Button component="a" href={href}>Link to this analysis</Button>
        {session && <TraceLink sessionId={session} label="Open detailed trace" />}
      </DialogContent>
      <DialogActions><Button onClick={() => setOpen(false)}>Close</Button></DialogActions>
    </Dialog>
  </>;
}
